<template>
  <fragment>
    <Label v-bind="labelProps" :html-for="id" :bold="labelBold" v-if="label">
      {{ label }}
    </Label>
    <b-input
      class="input"
      :class="inputClass"
      :id="id"
      @input="updateValue"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      :minlength="minlength"
      :type="type"
      :min="min"
      :max="max"
      v-on:keyup.enter="handleOnEnter"
      @keydown="handleOnKeyDown"
      @blur="blur"
      @change="change"
      :key="`input-without-mask-${id}`"
      v-if="!mask"
    />
    <b-input
      v-else
      class="input"
      :class="inputClass"
      :id="id"
      @input="updateValue"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      :minlength="minlength"
      :type="type"
      :min="min"
      :max="max"
      v-on:keyup.enter="handleOnEnter"
      @keydown="handleOnKeyDown"
      @blur="blur"
      @change="change"
      v-mask="mask"
      :key="`input-with-mask-${id}`"
    />
    <div
      class="input-description input-margin"
      v-if="description"
      :class="descriptionClass"
    >
      {{ description }}
    </div>
  </fragment>
</template>

<script>
import Label from './Label';

export default {
  name: 'Input',
  components: {
    Label,
  },
  props: {
    id: {
      type: String,
      required: false,
    },
    value: {},
    label: {
      type: String,
    },
    type: {
      type: String,
      default: () => 'text',
    },
    maxlength: {
      type: Number,
    },
    minlength: {
      type: Number,
    },
    max: {
      type: Number,
    },
    min: {
      type: Number,
    },
    labelBold: {
      type: Boolean,
      default: () => false,
    },
    labelProps: {
      type: Object,
    },
    placeholder: {
      type: String,
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: () => false,
    },
    required: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    onEnter: {
      type: Function,
      default: () => {},
    },
    onKeyDown: {
      type: Function,
      default: () => {},
    },
    mask: {
      type: Array,
    },
  },
  methods: {
    handleOnEnter() {
      this.onEnter();
    },
    handleOnKeyDown(e) {
      this.onKeyDown(e);
    },
    blur(e) {
      this.$emit('blur', e);
    },
    change(e) {
      this.$emit('change', e);
    },
    updateValue(value) {
      this.$emit('input', value);
    },
  },
  computed: {
    inputClass() {
      return {
        'input-margin': !this.description,
        success: this.success,
        error: this.error || (this.required && !this.value),
      };
    },
    descriptionClass() {
      return {
        success: this.success,
        error: this.error || (this.required && !this.value),
      };
    },
  },
};
</script>
